import { useContext, useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';
import DivisionIcon from "../../components/Icons/divisionicon";
import './manageClient.css';
import Autocomplete from '@mui/material/Autocomplete';
import ManageDivisionDataTable from "../../components/manageDivisionDataTable/manageDivisionDataTable.js";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import checkRequisitionExists from "../../apis/checkRequisitionExists/checkRequisitionExists";

import {
    addDivision,
    updateDivision,
    getDivisionByOrg,
    getRecruitmentLeaderbyorg,
    getTeamByRecruitmentLeaderId
}
    from "../../apis/organisationAdminAPI/manageDivision";
import { NotificationManager } from "react-notifications";
import AddCircle from '@mui/icons-material/AddCircle';
import Cancel from '@mui/icons-material/Cancel';
import { UserTypeContext } from "../../AppRoute";
import "./managedivision.css";
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const ManageDivision = (props) => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const idContextTest = userType === 'Admin' ? location?.state?.id : userRecords?.id;
    const userRecruitmentpartnerId = userType === 'Admin' ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId;
    const userRole = userType === 'Admin' ? location?.state?.userType : userRecords?.role?.roleName;
    const userRecrodData = userType === 'Admin' ? location?.state?.userRecords : userRecords;
    const history = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);
    const [divisionData, setDivisionData] = useState([]);
    const [recruitmentLeaderOptions, setRecruitmentLeaderOptions] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [editedRow, setEditedRow] = useState({});
    const [isUserDataUpdating, setIsUserDataUpdating] = useState(false)
    const [teamLeaderOptions, setTeamLeaderOptions] = useState([]);
    const [isActiveFieldDisabled, setIsActiveFieldDisabled] = useState(false)
    const [divisionInfo, setDivisionInfo] = useState({
        divisionName: "",
        active: { name: "True", value: true },
    })
    const [leadersArr, setLeadersArr] = useState([
        {
            selectedRecruitmentLeader: {},
            selectedTeamLeaders: [],
            leaderOptionFetching: false
        },
    ])
    const [exisitingRequisition, setExisitingRequisition] = useState([])
    const activeDropDown = [
        { name: "True", value: true },
        { name: "False", value: false },
    ];

    const getRecruitmentLeadersData = async () => {
        try {
            let payload = {
                recruitmentpartnerId: userRecruitmentpartnerId,
                manageDivision: true,
            }
            let response = await getRecruitmentLeaderbyorg(payload);
            if (response.status === 200) {
                setRecruitmentLeaderOptions(response.data.data);
            }
            else {
                NotificationManager.error("Unable to retrieve recruitment leader data. Please try again later.", "Error", 10000);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleAddDivision = async () => {
        setEditedRow({});
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEditedRow({});
        setDivisionInfo({
            divisionName: "",
            active: { name: "True", value: true }
        })
        setLeadersArr([
            {
                selectedRecruitmentLeader: {},
                selectedTeamLeaders: [],
                leaderOptionFetching: false
            },
        ])
        setIsActiveFieldDisabled(true);
        setExisitingRequisition([])
    };


    const handleSubmit = async () => {
        if (divisionInfo.divisionName === "" ||
            leadersArr.some(item => !item.selectedRecruitmentLeader.id) ||
            leadersArr.some(item => item.selectedTeamLeaders.length === 0) ||
            divisionInfo.active === "") {
            return NotificationManager.error(
                "Please fill in all the fields",
                "Error",
                10000
            );
        }
        else {
            setIsUserDataUpdating(true);
            let teams = [];
            for (let i = 0; i < leadersArr.length; i++) {
                let item = leadersArr[i];
                let teamIds = [];
                for (let j = 0; j < item.selectedTeamLeaders.length; j++) {
                    let team = item.selectedTeamLeaders[j];
                    teamIds.push(team._id);
                }
                teams.push({
                    recruiterLeaderId: item.selectedRecruitmentLeader.id,
                    teamId: teamIds
                });
            }

            let payload = {
                divisionName: divisionInfo.divisionName,
                recruitmentpartnerId: userRecruitmentpartnerId,
                teams: teams,
                isActive: divisionInfo.active.value,
                updatedBy: idContextTest
            }
            if (Object.keys(editedRow).length > 0) {
                try {
                    let response = await updateDivision(editedRow._id, payload);
                    if (response.status === 200) {
                        NotificationManager.success("Division details updated successfully", "Success", 10000);
                        handleCloseDialog();
                        getRecruitmentLeadersData()
                        allDivisonData()
                    } else if (response.status === 202) {
                        const errorMessage = response.data.message;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                } catch (error) {
                    if (error.response.status === 400 && error.response.data.errorCode === 400) {
                        const errorMessage = error.response.data.errMessage;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                }
            }
            else {
                payload.createdBy = idContextTest;
                try {
                    let response = await addDivision(payload);
                    if (response.status === 200) {
                        NotificationManager.success("Division created successfully", "Success", 10000);
                        handleCloseDialog();
                        getRecruitmentLeadersData()
                        allDivisonData()
                    } else if (response.status === 202) {
                        const errorMessage = response.data.message;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                } catch (error) {
                    if (error.response.status === 400 && error.response.data.errorCode === 400) {
                        const errorMessage = error.response.data.errMessage;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                }
            }
            setIsUserDataUpdating(false);
        }
    };
    const allDivisonData = async () => {
        setIsDataLoading(true);
        setDivisionData([]);
        let payload = {
            recruitmentpartnerId: userRecruitmentpartnerId
        }
        try {
            let response = await getDivisionByOrg(payload);
            if (response.status === 200) {
                setDivisionData(response.data.data);
            }
            setIsDataLoading(false);
        } catch (error) {
            setDivisionData([]);
            setIsDataLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (userRecruitmentpartnerId && (
            userType === "Organization Admin" ||
            userType === "MIS Operator" ||
            (userType === "Admin" && userRole === "Organization Admin") ||
            (userType === "Admin" && userRole === "MIS Operator")
        )) {
            getRecruitmentLeadersData()
            allDivisonData()
        }
        //eslint-disable-next-line
    }, [userType])

    const handleDivisonName = (e) => {
        if (e.target.value) {
            setDivisionInfo({ ...divisionInfo, divisionName: e.target.value })
        } else {
            setDivisionInfo({ ...divisionInfo, divisionName: "" })
        }
    }
    const handleRecruitmentLeader = (e, value, index) => {
        let newArr = [...leadersArr];
        if (value) {
            newArr[index].selectedRecruitmentLeader = value;
            newArr[index].selectedTeamLeaders = [];
        }
        else {
            newArr[index].selectedRecruitmentLeader = {};
            newArr[index].selectedTeamLeaders = [];
        }
        setLeadersArr(newArr);
    }

    const handleActiveChange = async (e, value) => {
        if (value) {
            setDivisionInfo({ ...divisionInfo, active: value })
        }
        else {
            setDivisionInfo({ ...divisionInfo, active: "" })
        }
    }
    const handleEdit = async (rowData) => {
        setEditedRow(rowData);
        setDivisionInfo({
            ...divisionInfo,
            divisionName: rowData.divisionName,
            active: {
                name: rowData.isActive ? "True" : "False",
                value: rowData.isActive
            }
        })
        let teamDetails = rowData.teamDetails;
        let newArr = [];
        for (let index = 0; index < teamDetails.length; index++) {
            let item = teamDetails[index];
            let obj = {
                selectedRecruitmentLeader: item.recruiterLeaderDetails,
                selectedTeamLeaders: item.teamDetails,
                leaderOptionFetching: false
            };
            newArr.push(obj);
        }
        setLeadersArr(newArr);
        try {
            let payload = {
                recruitmentpartnerId: userRecruitmentpartnerId,
                divisionId: rowData._id,
                validation: "Division"
            }
            const response = await checkRequisitionExists(payload)
            setExisitingRequisition(response?.data?.data)
            const requisitionExists = response?.data?.data?.length;
            if (requisitionExists > 0) {
                setIsActiveFieldDisabled(true)
            }
            else {
                setIsActiveFieldDisabled(false)
            }
            setOpenDialog(true);

        } catch (error) {
            NotificationManager.error("Something Went Wrong!", "Error", 10000)
        }
    };
    const goToDashboard = () => {
        history("/dashboard",
            {
                state: {
                    userType: userType,
                    recruitmentPartnerId: userRecruitmentpartnerId,
                    id: idContextTest,
                    userRecords: userRecrodData,
                    roleName: userRole
                }
            });
    }

    const increaseLeaderArr = () => {
        setLeadersArr([...leadersArr, {
            selectedRecruitmentLeader: {},
            selectedTeamLeaders: []
        }])
    }
    const leadersArrItemClose = (item, index) => {
        let data = []
        if (Object.keys(item?.selectedRecruitmentLeader).length > 0) {
            data = exisitingRequisition.filter((value) =>
                value?.assignedTo === item.selectedRecruitmentLeader.id
                || value?.division?.recruitmentLeaderId === item.selectedRecruitmentLeader.id)
        }

        if (data.length > 0) {
            NotificationManager.error("Unable to make changes as a requisition already exists for this Recruitment Leader.", "Error", 10000)
        }
        else {
            let newArr = [...leadersArr];
            newArr.splice(index, 1);
            setLeadersArr(newArr);
        }
    }

    const checkDisbale_RecruitmentLeader = (item) => {
        let data = []
        if (Object.keys(item?.selectedRecruitmentLeader).length > 0) {
            data = exisitingRequisition.filter((value) =>
                value?.assignedTo === item.selectedRecruitmentLeader.id
                || value?.division?.recruitmentLeaderId === item.selectedRecruitmentLeader.id)
        }
        if (data?.length > 0) {
            return true
        }
        else {
            return false;
        }
    }

    const fetchTeamLeaders = async (e, index) => {
        setTeamLeaderOptions([]);
        let newArr = [...leadersArr];
        newArr[index].leaderOptionFetching = true;
        setLeadersArr(newArr);
        let payload = {
            recruiterLeaderId: leadersArr[index].selectedRecruitmentLeader.id,
            recruitmentpartnerId: userRecruitmentpartnerId
        }
        try {
            let response = await getTeamByRecruitmentLeaderId(payload);
            newArr[index].leaderOptionFetching = false;
            setLeadersArr(newArr);
            if (response.status === 200) {
                setTeamLeaderOptions(response.data.data);
            }
            else {
                NotificationManager.error("Unable to fetch team leaders", "Error", 10000);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const deleteTeamLeaderHandler = async (option, i, index) => {
        try {
            let payload = {
                teamId: option._id,
                recruitmentpartnerId: userRecruitmentpartnerId,
                validation: "Division"
            }
            const dataRes = await checkRequisitionExists(payload);
            if (dataRes?.status === 200 && dataRes?.data?.data.length > 0) {
                NotificationManager.error(
                    `${dataRes?.data?.message}`,
                    "error",
                    10000);
            } else if (dataRes.status === 400 && dataRes.errorCode === 400) {
                const errorMessage = dataRes.data.message;
                NotificationManager.error(errorMessage, "Error", 10000);

            } else {
                let oldArr = [...leadersArr];
                let teamLeaders = [...oldArr[index]?.selectedTeamLeaders];
                let newTeamLeader = [];
                for (let i = 0; i < teamLeaders.length; i++) {
                    if (teamLeaders[i]._id !== option._id) {
                        newTeamLeader.push(teamLeaders[i]);
                    }
                }
                oldArr[index] = {
                    ...oldArr[index],
                    selectedTeamLeaders: newTeamLeader
                };
                setLeadersArr(oldArr);
            }
        } catch (error) {
            NotificationManager.error("Something Went Wrong!", "error", 10000)
        }

    }

    const handleTeamLeaderChange = (e, value, index) => {

        if (value) {
            let newArr = [...leadersArr];
            newArr[index].selectedTeamLeaders = value;
            setLeadersArr(newArr);
        }
        else {
            let newArr = [...leadersArr];
            newArr[index].selectedTeamLeaders = [];
            setLeadersArr(newArr);
        }
    }

    const getFilteredRecruiterLeaderOptions = () => {
        let filteredOptions = recruitmentLeaderOptions.filter(item => {
            let isAlreadySelected = false;
            leadersArr.forEach(leader => {
                if (leader.selectedRecruitmentLeader.id === item.id) {
                    isAlreadySelected = true;
                }
            })
            return !isAlreadySelected;
        })
        return filteredOptions
    }

    const getFilteredTeamLeaderOptions = (item) => {
        if (teamLeaderOptions.length > 0) {
            let filteredOptions = teamLeaderOptions.filter(teamLeader => {
                let isAlreadySelected = false;
                item.selectedTeamLeaders.forEach(selectedTeamLeader => {
                    if (selectedTeamLeader._id === teamLeader._id) {
                        isAlreadySelected = true;
                    }
                })
                return !isAlreadySelected;
            })
            return filteredOptions
        }
        else {
            return [];
        }
    }

    return (
        <>
            {(userType === "Organization Admin" || userType === "MIS Operator") || (userType === 'Admin' && userRole === 'Organization Admin') || (userType === 'Admin' && userRole === 'MIS Operator') ?
                <>
                    <div className="manegeDivision_container">
                        <div className="manageDivision_header_container">
                            <div className="manageDivision_header_left">
                                <div className="manageDivision_goBackButton" onClick={(e) => goToDashboard(e)}>
                                    <Tooltip title="Go Back to Dashboard" placement="bottom">
                                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                                    </Tooltip>
                                </div>
                                <div className="manageDivision_title">Manage Division</div>
                            </div>
                            {userType === 'Admin' ? "" :
                                <div className="manageDivision_header_right">
                                    <Button className="manageDivision_addButton"
                                        onClick={handleAddDivision}
                                        startIcon={<DivisionIcon />}
                                    >
                                        Add Division
                                    </Button>
                                </div>
                            }
                        </div>
                        <ManageDivisionDataTable divisionData={divisionData} isDataLoading={isDataLoading} onEdit={handleEdit} userType={userType} />
                    </div>
                </>
                :
                <UnauthorizedAccess />
            }
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="dialog-title"
                maxWidth="sm"
                fullWidth
                className="add-division"
            >
                <div className="division_dialog_modal" >
                    <div className='division-dialog-TitleContainer'>
                        <DivisionIcon alt="Manage division" className="iconStyle" />
                        <span className="dialog-title-text">{Object.keys(editedRow).length > 0 ? 'Edit Division' : 'Add Division'}</span>
                    </div>
                </div>
                <DialogContent className="division-dialog-content">
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-division-dialog">Division Name*</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Division Name"
                                className="input-field-division-dialog"
                                value={divisionInfo.divisionName}
                                onChange={handleDivisonName}
                            />
                        </Grid>

                        {leadersArr.map((item, index) => (
                            <Grid container spacing={2} size={{ xs: 12 }} key={`leadersArr_${index}`}>
                                <Grid size={leadersArr.length > 1 ? 5 : 6}>
                                    <Typography className="field-title-division-dialog">Recruitment Leader*</Typography>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        value={item.selectedRecruitmentLeader}
                                        options={getFilteredRecruiterLeaderOptions()}
                                        disabled={checkDisbale_RecruitmentLeader(item)}
                                        filterSelectedOptions
                                        getOptionLabel={(option) => option.email || ""}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Recruitment Leader"
                                            />
                                        )}
                                        onChange={(e, value) => handleRecruitmentLeader(e, value, index)}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <Typography className="field-title-division-dialog">Team*</Typography>

                                    <FormControl fullWidth variant="outlined">
                                        <Autocomplete
                                            multiple
                                            id="combo-box-demo"
                                            options={getFilteredTeamLeaderOptions(item)}
                                            value={item.selectedTeamLeaders}
                                            disableClearable
                                            filterSelectedOptions
                                            getOptionLabel={(option) => option.teamName}
                                            onFocus={(e) => fetchTeamLeaders(e, index)}
                                            loading={item.leaderOptionFetching}
                                            onChange={(e, value) => handleTeamLeaderChange(e, value, index)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Select Team"
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Backspace') {
                                                            event.stopPropagation();
                                                        }
                                                    }}
                                                    style={{ backgroundColor: '#fff', color: '#000', borderRadius: 4, borderColor: '#31b3f8' }}
                                                />
                                            )}
                                            renderTags={(value, getTagProps) => {
                                                return (
                                                    value.map((option, i) => (
                                                        <Chip
                                                            label={option.teamName}
                                                            {...getTagProps({ i })}
                                                            onDelete={() => deleteTeamLeaderHandler(option, i, index)}
                                                        />
                                                    ))
                                                );
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    {leadersArr.length > 1 ?
                                        <Cancel className="cancelIcon_leadersArr" onClick={(e) => leadersArrItemClose(item, index)} />
                                        : ""}
                                </Grid>
                            </Grid>
                        ))}

                        <Grid size={{ xs: 12 }} className="addButtonGrid_addLeadersArr">
                            <AddCircle
                                color="primary"
                                onClick={increaseLeaderArr}
                                className="addIcon_leadersArr"
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-division-dialog">Is Active*</Typography>
                            <Autocomplete
                                id="combo-box-demo"
                                value={divisionInfo.active}
                                options={activeDropDown}
                                disabled={editedRow ? isActiveFieldDisabled : false}
                                getOptionLabel={(option) => option?.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Active"
                                    />
                                )}
                                onChange={handleActiveChange}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-actionbutton-division">
                    <button onClick={handleCloseDialog} className="cancel-button-division">
                        Cancel
                    </button>
                    <button
                        className={isUserDataUpdating ? 'updateButton-division_disabled' : 'updateButton-division'}
                        onClick={handleSubmit}
                        disabled={isUserDataUpdating}
                    >
                        <span>Save</span>
                        {isUserDataUpdating ? (<CircularProgress className="circularProgress_updateButton" />) : null}
                    </button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ManageDivision;